import React from 'react';

import { type SizeType } from '../../features/config';

import { type BreadcrumbItem, useBreadcrumb } from './Breadcrumb.context';
import * as Primitives from './Breadcrumb.parts';

export type BreadcrumbProps = {
    items: BreadcrumbItem[];
    className?: string;
    onItemClick?: (id: string) => void;
    size?: SizeType;
    visibleItemsAmount?: number;
    minVisibleItemsAmount?: number;
};

const BreadcrumbRoot = ({
    className,
    onItemClick,
    items,
    size,
    visibleItemsAmount,
    minVisibleItemsAmount = 1,
    ...rest
}: BreadcrumbProps) => {
    const breadcrumb = useBreadcrumb({
        items,
        size,
        visibleItemsAmount,
        minVisibleItemsAmount
    });
    return (
        <Primitives.Root breadcrumb={breadcrumb} className={className} {...rest}>
            <Primitives.Items>
                <Primitives.Rest onItemClick={onItemClick} />
                {breadcrumb.items.map((item) => (
                    <Primitives.Item key={item.id} item={item} onItemClick={onItemClick} />
                ))}
            </Primitives.Items>
        </Primitives.Root>
    );
};

type BreadcrumbCompound = typeof BreadcrumbRoot & typeof Primitives;

export const Breadcrumb = Object.assign(BreadcrumbRoot, Primitives) as BreadcrumbCompound;
